var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable consistent-return */
import React, { createContext, useState } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { gotoLogonModule } from '../../components/Utils';
import { B2B_VALIDATE_AGREEMENT_CODE, B2B_ENROLL_AGREEMENT_CODE, B2B_UNENROLL_AGREEMENT_CODE, } from '../../constants/links';
import { newrelic, PRICING_BOOK_NATIONAL_ENROLL, PRICING_BOOK_NATIONAL_UNENROLL, } from '../../utils/newrelic';
var NationalAccountContext = createContext(null);
var errorMessageHelper = function (error) {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'System error';
};
var NationalAccountProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), showModal = _b[0], setShowModal = _b[1];
    var _c = useState(false), errorState = _c[0], setErrorState = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(false), isMobile = _e[0], setIsMobile = _e[1];
    var _f = useState({}), currentAgreementCode = _f[0], setCurrentAgreementCode = _f[1];
    var _g = useState({
        enrollState: false,
        requiredEINState: {},
        agreementCodeNameEntered: {},
        agreementCodeEntered: {},
        validatedState: {},
        agreementType: {},
        einGovState: false,
    }), validResponseState = _g[0], setValidResponseState = _g[1];
    var isPricingBookEnabled = !!useConfigService('ENABLE_NEW_PRICING_BENEFIT_PAGE');
    var getUserInfo = React.useCallback(function () {
        var getTHDCustomer = function () {
            var _a;
            return typeof window !== 'undefined'
                ? (_a = window === null || window === void 0 ? void 0 : window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default
                : {};
        };
        var _a = getTHDCustomer(), svocID = _a.svocID, userID = _a.userID, jwt = _a.jwt;
        return { svocID: svocID, userID: userID, jwt: jwt };
    }, []);
    var fetchValidateAgreementCode = React.useCallback(function (agreementCode) { return __awaiter(void 0, void 0, void 0, function () {
        var url, fullURL, jwt, response, res, error_1, errorMessage;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = B2B_VALIDATE_AGREEMENT_CODE;
                    fullURL = "".concat(url, "/").concat(agreementCode);
                    jwt = getUserInfo().jwt;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(fullURL, {
                            method: 'GET',
                            credentials: 'include',
                            headers: {
                                channelId: '1',
                                'Content-Type': 'application/json',
                                TMXProfileID: window.THD_ACCOUNT_LIB.TMX.getTMXsessionId(),
                                Authorization: jwt,
                            },
                        })];
                case 2:
                    response = _b.sent();
                    if (response.status === 401 || response.status === 431) {
                        gotoLogonModule();
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    res = _b.sent();
                    if (response.status === 404) {
                        return [2 /*return*/, {
                                data: {},
                                status: 404,
                                error: 'Agreement Code Could Not Be Found',
                                hasError: true,
                            }];
                    }
                    if ((response.status >= 500 && response.status < 599) ||
                        response.status === 403) {
                        return [2 /*return*/, {
                                data: {},
                                status: 500,
                                error: '500 Server Error',
                                hasError: true,
                            }];
                    }
                    if (((_a = res === null || res === void 0 ? void 0 : res.errors) === null || _a === void 0 ? void 0 : _a.length) > 0)
                        return [2 /*return*/, {
                                data: {},
                                error: res === null || res === void 0 ? void 0 : res.errors[0],
                                hasError: true,
                            }];
                    if (response.status === 200 && !(res === null || res === void 0 ? void 0 : res.errors)) {
                        return [2 /*return*/, { data: res, error: null, hasError: false }];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    errorMessage = errorMessageHelper(error_1);
                    return [2 /*return*/, {
                            data: {},
                            error: errorMessage,
                            hasError: true,
                        }];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var enrollAgreementCode = React.useCallback(function (isEnroll, agreementCode, einCodeUserInput) { return __awaiter(void 0, void 0, void 0, function () {
        var url, jwt, response, error_2, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = isEnroll
                        ? B2B_ENROLL_AGREEMENT_CODE
                        : B2B_UNENROLL_AGREEMENT_CODE;
                    jwt = getUserInfo().jwt;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            credentials: 'include',
                            headers: {
                                channelId: '1',
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                                'User-Agent': 'neoload',
                                TMXProfileID: window.THD_ACCOUNT_LIB.TMX.getTMXsessionId(),
                                Authorization: jwt,
                            },
                            body: JSON.stringify({
                                nationalAgreementCodeRequest: {
                                    abbreviatedName: agreementCode,
                                    EIN: einCodeUserInput,
                                },
                            }),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.status === 204) {
                        if (isPricingBookEnabled) {
                            newrelic.addPageAction(isEnroll
                                ? PRICING_BOOK_NATIONAL_ENROLL
                                : PRICING_BOOK_NATIONAL_UNENROLL, {
                                result: 'success',
                            });
                        }
                        return [2 /*return*/, {
                                data: 'Success',
                                status: response.status,
                                error: null,
                                hasError: false,
                            }];
                    }
                    if (response.status === 401 || response.status === 431) {
                        gotoLogonModule();
                    }
                    if (isPricingBookEnabled) {
                        newrelic.addPageAction(isEnroll
                            ? PRICING_BOOK_NATIONAL_ENROLL
                            : PRICING_BOOK_NATIONAL_UNENROLL, {
                            result: 'error',
                            errorMessage: response.status === 401 || response.status === 431
                                ? 'Authentication Error'
                                : 'Agreement Code Could Not Be Found',
                        });
                    }
                    return [2 /*return*/, {
                            data: {},
                            status: response.status,
                            error: 'Agreement Code Could Not Be Found',
                            hasError: true,
                        }];
                case 3:
                    error_2 = _a.sent();
                    errorMessage = errorMessageHelper(error_2);
                    if (isPricingBookEnabled) {
                        newrelic.addPageAction(isEnroll
                            ? PRICING_BOOK_NATIONAL_ENROLL
                            : PRICING_BOOK_NATIONAL_UNENROLL, {
                            result: 'error',
                            errorMessage: errorMessage,
                        });
                    }
                    return [2 /*return*/, {
                            data: {},
                            error: errorMessage,
                            hasError: true,
                        }];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    return (React.createElement(NationalAccountContext.Provider, { value: {
            validResponseState: validResponseState,
            setValidResponseState: setValidResponseState,
            errorState: errorState,
            setErrorState: setErrorState,
            setShowModal: setShowModal,
            showModal: showModal,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            isMobile: isMobile,
            setIsMobile: setIsMobile,
            currentAgreementCode: currentAgreementCode,
            setCurrentAgreementCode: setCurrentAgreementCode,
            fetchValidateAgreementCode: fetchValidateAgreementCode,
            enrollAgreementCode: enrollAgreementCode,
        } }, children));
};
export { NationalAccountProvider, NationalAccountContext };
